import { useEffect, useState } from "react"
import { X } from "react-feather"
import ScrollBar from "react-perfect-scrollbar"
import { Badge, Card, CardBody, Modal, ModalBody, ModalHeader } from "reactstrap"
import api from "../../services/api"
import './releases.scss'
export default function Realases(props) {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    api.get('/perfil/releases').then((response) => {
      const {data} = response.data
      setData(data)
      setLoading(true)
    })
  }, [])
  return (
    <div>
      <Modal 
        isOpen={props.open}
        toggle={props.click}
        modalClassName="modal-slide-in sidebar-todo-modal"
        className=" modal-release bg-secondary"
        > 
        <ModalHeader className='modal-header-filter'>
          <div className='d-flex justify-content-between container-title-header'>
          <div>
          <h1 >Novidades 📣</h1>
          </div>
          <X onClick={props.click} />
          </div>
          <span>Fique ligado no que  há de novo no Tributei</span>
          <hr />
        </ModalHeader>
        <ScrollBar className="scroll-release">
        <ModalBody className="container-body-modal  d-flex gap-2 b flex-column ">
            {loading ? data.map((item) => {
              return (
                <Card key={item.id}>
                  <CardBody className="border-bottom  d-flex flex-column gap-1">
                  <div className="d-flex  gap-1"> 
                    {item.tags.length > 0 ? item.tags.map((tag) => {
                      return (
                          <Badge key={tag.classe} color={tag.classe === "success" || tag.classe === "light-primary" ? "light-primary" : "danger"}>{tag.titulo}</Badge>
                          )
                        }) : null}
                    </div>
                    <a href={item.link_artigo} target="_blank" rel="noopener noreferrer">
                    <h2>{item.titulo}</h2>
                    </a>
                    <div dangerouslySetInnerHTML={{__html:item.descricao}}></div>
                    {item.midia.tipo === "img" ? <div className="mb-3 d-flex justify-content-center align-items-center release-img">
                      <img 
                      // src={Teste} 
                      src={`https://sandboxapi.tributei.net/storage/${item.midia.link}`} 
                      alt={item.titulo}  />
                    </div> : null}
                  </CardBody>
                </Card>
              )
            }) : null}
        </ModalBody>
            </ScrollBar>
      </Modal>
    </div>
  )
}